import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  SmartAlert,
  SmartFormInterFace,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { SdsFsDownloadFile } from "soft_digi/dist/services/FileService";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { checkInterSection } from "../../services/core/FilterService";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
import ChangeDateForm from "../Home/ChangeDateForm";
import SessionForm from "./SessionForm";
import { SmartHeadButton } from "soft_digi/dist/tables/SmartTableNewInterface";
// import ChangeDateForm from "./ChangeDateForm";
import ExcelJS from "exceljs";
import SessionUpdateForm from "./SessionUpdateForm";

interface HeaderProps {
  mode: string;
}

const TraineesTable: React.FC<HeaderProps> = ({ mode }) => {
  const { openModal, closeModal, user } = useSiteContext();
  const navigate = useNavigate();
  const [tabData, setTabData] = useState([]);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const is_admin = checkInterSection(user?.roles || [], ["ADMIN", "AGENCY"]);

  const loadTableData = () => {
    let URL = SESSION_URLS.GET_ALL_TRAINER;
    let data_in = {
      status: mode,
    };
    const subscription = post(URL, data_in).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);
  const CancelData = (id: any) => {
    const subscription = post(SESSION_URLS.CANCEL_SESSION, {
      id: id,
    }).subscribe((response) => {
      showAlertAutoClose("Cancel Successfully...", "success");
      closeModal();
      loadTableData();
      // setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openCancelModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Session Cancel!
        </span>
      ),
      alertFunction: (option) => {
        if (option === "yes") {
          CancelData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to Cancel this Session? This action cannot be
          reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  // const viewEditForm = (data:any) => {
  //  // const selectedData = staticTabData.find((data) => data.ID === id);

  //  openChangeForm(data);
  // };
  const updateSessionDateForm = (id: any) => {
    const subscription = post(SESSION_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openDateUpdateForm(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
    const openDateUpdateForm = (data: any) => {
    let options = {
      title: <p> Update Session Dates</p>,
      content: <SessionUpdateForm dataIn={data} loadTableData={loadTableData} />,
      className: " sd-exam-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
  const viewEditForm = (id: any) => {
    const subscription = post(SESSION_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openChangeForm(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
  const openOfficesForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Session Update Form" : "Session Form"}</>,
      content: <SessionForm dataIn={data} loadTableData={loadTableData} />,
      className: " sd-exam-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
  const openChangeForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Change Date Form" : "Change Date Form"}</>,
      content: <ChangeDateForm dataIn={data} loadTableData={loadTableData} />,
      className: "sd-efl-modal sd-exam-modal-one",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };

const onSubmit = (dt: any) => {
  const url = SESSION_URLS.GET_PDF;
  const sessionId = dt["session_id"] || "Session";
  const sessionDate = dt["session_date"]
    ? new Date(dt["session_date"]).toLocaleDateString("en-GB").split("/").reverse().join("-")
    : "Date";

  const fileName = `${sessionId}_${sessionDate}_Report.pdf`;

  const subscription = post(
    url,
    { id: dt["ID"] },
    { loadingMsg: "Downloading... please Wait" }
  ).subscribe((response) => {
    SdsFsDownloadFile(response.data.content, fileName);
  });

  return () => {
    subscription.unsubscribe();
  };
};

  const buttons = [
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-eye",
      classList: ["smart-hims-table-view-icon"],
      onClick: (data: any) => navigate("/admin/session/" + data["ID"]),
      // hideFunction: (d: any) => {
      //   return mode === "planned" || d?.status?.toLowerCase() === "planned";
      // },
    },

    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-clock",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => viewEditForm(data["ID"]),
      hideFunction: (d: any) => is_admin || d?.status !== "active",
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-times",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => openCancelModal(data["ID"]),
      hideFunction: (d: any) => is_admin || d?.status !== "active",
    },

    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-edit",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => updateSessionDateForm(data["ID"]),
     // hideFunction: (d: any) => mode == "today",
    },
    
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-download",
      classList: ["smart-hims-table-view-icon"],
      onClick: (data: any) => onSubmit(data),
      // hideFunction: (data: any) => {
      //   return data["status"] == "completed" ? false : true;
      // },
       hideFunction: (d: any) =>  d?.status !== "completed",
    },
  ];

  // const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
  //   { title: "S.NO", index: "s_no", type: "sno", width: "5" },
  //   { title: "Employee ID", index: "euserid" },
  //   { title: "Name", index: "ename" },
  //   { title: "Mobile Number", index: "mobile_no" },
  //   { title: "Loco -shed", index: "roles" },
  //   {
  //     title: "Action",
  //     index: "action",
  //     type: "buttons",
  //     buttons: buttons,
  //     width: "10",
  //   },
  // ];

  const exportexl = async (dataToExport: any[]) => {
        const title = "Session Report";
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(title);
    
        const headers = [
          "S.NO",
          "Agency",
          "Project",
          "Session ID",
          "Date",
          "Venue",
          "No.of Loco Pilots",
          "status",
          
        ];
    
        worksheet.mergeCells(`A1:F1`);
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Session Report";
        titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFF" } };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };
        titleCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "4472C4" },
        };
    
        worksheet.addRow(headers);
        const headerRow = worksheet.getRow(2);
        headerRow.eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9E1F2" },
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
    
        dataToExport.forEach((item, index) => {
          const row = [
            index + 1,
            item.agency_name || "",
            item.project_name || "",
            item.session_label||"",
            item.session_date || "",
            item.location||"",
            item.total_trainees || "",
            item.status || "",
            
          ];
    
          const addedRow = worksheet.addRow(row);
          addedRow.eachCell((cell) => {
            cell.alignment = { vertical: "middle", wrapText: true };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });
    
        worksheet.columns.forEach((col) => {
          col.width = 20;
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
    
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "LocoPilotExport.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

  const statusTags = [
    { value: "started", label: "Started", class: "is-info" },
    { value: "active", label: "Active", class: "is-primary" },
    { value: "cancel", label: "Cancel", class: "is-danger" },
    { value: "completed", label: "Completed", class: "is-primary" },
  ];
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Agency", index: "agency_name" },
    { title: "Project", index: "project_name" ,  isSortable: true,},
    { title: "Session ID", index: "session_id" },

    {
      title: "Date",
      index: "session_date",
      type: "date",
      dateFormat: "DD-MM-YYYY",
    },
    { title: "Venue", index: "location" },
    { title: "No.of Loco Pilots", index: "total_trainees" },
    { title: "status", index: "status", type: "tags", tags: statusTags },
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "15",
    },
  ];

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
    {
      type: "CUSTOM",
      widthClass: "is-1",
      align: "CENTER",
      classList: ["mobile-search-toggle"],
      custom: (
        <span
          className="icon is-size-4 is-clickable has-text-grey-dark"
          onClick={() => setMobileSearchOpen((s) => !s)}
          aria-label="Toggle search"
        >
          <i className={`fa ${mobileSearchOpen ? "fa-times" : "fa-search"}`}></i>
        </span>
      ),
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },

     {
      type: "CUSTOM",
      widthClass: "is-1",
      align: "CENTER",
      custom: (

        
        <div className="is-size-4">
         
{mode=="completed"?<>
 <span
            className="icon ml-4 mx-3 is-clickable excel-export-icon"
            onClick={() => exportexl(tabData)}
            data-tooltip-id="export-tooltip"
            data-tooltip-content="Export"
          >
            <i className="fa fa-upload"></i>
          </span>
</>:<></>}
         
        </div>
      ),
    },

    
   {
  type: "BUTTONS",
  widthClass: "is-1",
  align: "CENTER",
  buttons: [
    ...(mode !== "completed"
      ? [{
            type: "FILTER",
            className: "",
          },
        
        ]
      : [
          // {
          //   type: "EXPORT",
          //   className: "smart-third-button",
          // },
          {
            type: "FILTER",
            className: "",
          },
        ]),
  ] as SmartHeadButton[],
},
   {
  type: "BUTTONS",
  widthClass: "is-2",
  align: "CENTER",
  buttons: [
     ...(mode !== "today"
      ? [
        
        ]
      : [
           {
            label: "Create",
            icon: "fa-plus",
            type: "CUSTOM",
            className: "smart-third-button",
            action: () => openOfficesForm({}),
          },
        ])as SmartHeadButton[],

        
  ]}


  ];

  const tableTopAdmin: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
     {
  type: "BUTTONS",
  widthClass: "is-2",
  align: "CENTER",
  buttons: [
    
          {
            type: "FILTER",
            className: "",
          },
        
  ] 
},
  ];

   const filterFields: SmartFormInterFace.SmartFormElementProps[] = [
          {
      type: "SELECT_BOX",
      width: "12",
      name: "project_name",
      class_name: "is-small",
      element: {
        label: "Project Name",
       size: "small",
        options: [
          { value: "WR", label: "WR" },
          { value: "NCR", label: "NCR" },
          { value: "WCR", label: "WCR" },
          { value: "SCR", label: "SCR" },
          { value: "ER", label: "ER" },

          { value: "CR-Bhusawal", label: "CR-Bhusawal" },
          { value: "CR-Nagpur", label: "CR-Nagpur" },
          { value: "CR-Solapur", label: "CR-Solapur" },
          { value: "CR-Mumbai", label: "CR-Mumbai" },
          { value: "CR-Pune", label: "CR-Pune" },

          { value: "WR-Ratlam", label: "WR-Ratlam" },
          { value: "WR-Ahmedabad", label: "WR-Ahmedabad" },
          { value: "WR-Rajkot", label: "WR-Rajkot" },
        ],
      },
    },
    ];

  return (
    <div
      className={`sd-efl-input trainees-table-wrap ${
        mobileSearchOpen ? "is-mobile-search-open" : ""
      }`}
    >
      <SmartTable
        columns={columns}
        data={tabData}
        tableTop={is_admin ? tableTopAdmin : tableTop}
        filterFields={filterFields}
        tableProps={{
          className: "is-hoverable is-bordered smart-hims-table",
          isResponsive: true,
          searchPlaceHolder: "Search",
        }}
        paginationProps={{
          pageSize: 10,
        }}
      />
    </div>
  );
};

export default TraineesTable;
